import { Pagination } from '@mui/material';
import React from 'react';

export default function PaginationFooter({
  pagination = false,
  totalCount = 0,
  tableData = [],
  page = 0,
  handleChangePage = () => {},
  noOfRecords = 5,
}) {
  const totalPages = pagination ? Math.ceil(tableData.length / noOfRecords) : Math.ceil(totalCount / noOfRecords);

  return (
    <Pagination
      count={totalPages}
      page={page + 1}
      onChange={(event, value) => handleChangePage(event, value - 1)}
      variant="outlined"
      shape="rounded"
      size="small"
      sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', mt: 2 }}
    />
  );
}
